<template>
  <div class="app-container">
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" class="demo-form-inline" label-width="90px" size="mini" :model="searchForm">
        <el-form-item label="时间范围:">
          <el-date-picker
            v-model="queryTime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </el-form-item>
       <el-form-item label="所属小队:" >
          <el-select v-model="searchForm.teamOrgId" filterable placeholder="请选择" clearable >
            <el-option  label="全部" value="" ></el-option>
            <el-option v-for="item in XDList" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <div style="display: flex;align-items: center;padding-right: 20px;">
          <div class="searchBtnBox" style="flex-shrink:0">
            <el-button type="primary" size="mini" @click="searchFn">查询</el-button>
            <el-button type="primary" size="mini" @click="resetForm('searchForm')">重置</el-button>
            <el-button type="primary" @click="exportFn" size="mini" :disabled="isDaoChu">导出</el-button>
          </div>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{ height: h }">
      <el-table :data="tableList" ref="table" bordersize="mini" height="100%" style="width: 100%" class="tableComent" highlight-current-row center
      border :cell-style="setCellStyle" >
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column prop="value1" width="" label="车牌号"></el-table-column>
        <el-table-column prop="value2" width="" label="所属小队"></el-table-column>
        <el-table-column prop="value3" width="" label="项目名称"></el-table-column>
        <el-table-column prop="value4" width="" label="总运单数"></el-table-column>
        <el-table-column prop="value5" width="" label="拉运完成量"></el-table-column>
        <el-table-column prop="value6" width="" label="平均单趟拉运量"></el-table-column>
        <el-table-column prop="value7" width="" label="运单总里程数"></el-table-column>
      </el-table>
    </div>
    <!-- 分页-->
    <div>
      <!-- <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchForm.pageNo" :page-sizes="[10, 20, 25, 50, 100]" :page-size="searchForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination> -->
    </div>
  </div>
</template>
<script>
import { getBtn } from '@/utils/getButton'
import { vehicleTransportReport } from '@/api/newTMS'
import { dateFormat1, dateTimeFormat, emptyFn, toFixed } from '@/utils/util'
import { organizationTree } from '@/api/vgs-driver2.0'
import { exportExcel } from '@/utils/fileDownXlsx.js'
export default {
  name: 'BasicMeterial',
  components: { },
  data () {
    return {
      toFixed: toFixed,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      queryTime: [],
      searchForm: {

      },
      tableList: [],
      total: 0,
      // 按钮
      btnFlg: [],
      btnIdArr: [],
      h: '',
      XDList: [],
      isDaoChu: false
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/chelianglayunbaobiao')
    organizationTree({ flag: 1 }).then((res) => {
      if (res[0].orgType == 1) {
        this.XDList = res[0].children
      } else {
        this.XDList = res
      }
    })
    this.initQueryTime()
    this.masterList()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 140 + 'px'
  },
  methods: {
    getLastMonthRange () {
      const end = new Date()
      // 设置结束时间为当天的 23:59:59
      end.setHours(23, 59, 59, 999)

      const start = new Date()
      start.setDate(start.getDate() - 30)
      // 设置开始时间为当天的 00:00:00
      start.setHours(0, 0, 0, 0)

      return {
        startTime: this.formatDateTime(start),
        endTime: this.formatDateTime(end)
      }
    },

    // 格式化时间为 yyyy-MM-dd HH:mm:ss
    formatDateTime (date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    initQueryTime () {
      const { startTime, endTime } = this.getLastMonthRange()
      this.queryTime = [startTime, endTime]
    },
    // 设置单元格样式
    setCellStyle ({ row, column, rowIndex, columnIndex }) {
      // 判断 teamName 是否为"合计"
      if (row.value2 === '合计') {
        // 如果是序号列，将内容设为空字符串
        if (column.type === 'index') {
          return {
            color: '',
            fontWeight: '',
            '&::before': {
              content: '""' // 伪元素方式清空内容
            }
          }
        }
        return {
          color: '#1890ff',
          fontWeight: 'bold'
        }
      }
      return null
    },
    masterList () {
      this.$set(this.searchForm, 'startTimeString', this.queryTime[0])
      this.$set(this.searchForm, 'endTimeString', this.queryTime[1])
      const loading = this.$loading({
        lock: true,
        text: '加载中...'
      })
      vehicleTransportReport(this.searchForm)
        .then(res => {
          console.log(res)
          loading.close()
          this.tableList = res
          // this.total = res.total
        })
        .catch(err => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
    },
    searchFn () {
      this.masterList()
    },
    // 重置
    resetForm (formName) {
      this.searchForm = {}
      this.initQueryTime()
      this.searchFn()
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchForm.pageSize = val
      this.masterList()
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchForm.pageNo = val
      this.masterList()
    },
    // 导出
    exportFn () {
      let form = { ...this.searchForm }
      exportExcel(
        this.global.tmsPlus + '/tReportDataView/exportVehicleTransportReportt',
        form,
        '车辆拉运报表'
      )
      this.isDaoChu = true
      setTimeout(() => {
        this.isDaoChu = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    }
  }
}
</script>

<style scoped lang="less">
</style>
